<template>
    <div class="main-content overflow-hidden">
        <div class="container-fluid" v-if="dataFetch">
            <div v-if="dataFetch" class="b-block pt-5">
                <div class="row">
                    <div class="col-6 mb-4">
                        <div class="d-flex flex-column h-100">
                            <div class="d-block flex-1">
                                <p>Loading... <i class="fa fa-spin fa-spinner"></i> </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!dataFetch">
            <AdminDashboard v-if="users.role == 'administrator'"></AdminDashboard>
            <TeacherDashboard v-if="users.role == 'teacher'"></TeacherDashboard>
        </div>
    </div>
</template>

<script>
import AdminDashboard from './admin.vue'
import TeacherDashboard from './teacher.vue'

export default {
    name: 'DashboardAdmin',
    metaInfo: {
        title: 'Dashboard',
        titleTemplate: '%s - Rasionalisasi Rapor'
    },
    components: {
        AdminDashboard,
        TeacherDashboard
    },
    data() {
        return {
            dataFetch   : true,
            users       : [],
        }
    },
    created() {
        this.dataFetch = true;
        setTimeout(() => {
            this.users      = this.$parent.$parent.users;
            this.dataFetch  = false;
        }, 1000);
    }
}
</script>
